module.exports = __webpack_public_path__ + "assets/img/csz.aa559428.png";